import { render } from "./social.vue?vue&type=template&id=8aea49e2&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8aea49e2"

export default script